import React, { useState } from 'react';
import { showError } from './ToastNotifications';

// Tiny "Copy" chip: puts `text` on the clipboard and says "Copied" for a
// moment. Used where staff must re-type something exactly (e.g. the
// "PR <payer> <amount>" line sales forward after finance records a receipt,
// operator 2026-10-20). Falls back to a hidden textarea + execCommand on
// browsers without the async clipboard API (older in-app webviews).
export default function CopyTextButton({ text, label = 'Copy', title, style }) {
  const [done, setDone] = useState(false);
  if (!text) return null;
  const copy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const ta = document.createElement('textarea');
        ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
      }
      setDone(true);
      setTimeout(() => setDone(false), 1600);
    } catch (err) {
      showError('Could not copy — long-press the text to copy it instead');
    }
  };
  return (
    <button
      type="button"
      onClick={copy}
      title={title || `Copy: ${text}`}
      aria-label={title || `Copy ${text}`}
      style={{
        marginLeft: 6, padding: '1px 8px', fontSize: 11, lineHeight: '18px', borderRadius: 10, cursor: 'pointer',
        border: `1px solid ${done ? '#86efac' : '#cbd5e1'}`, background: done ? '#f0fdf4' : '#fff', color: done ? '#166534' : '#374151',
        verticalAlign: 'middle', whiteSpace: 'nowrap', ...style,
      }}
    >
      {done ? 'Copied ✓' : `📋 ${label}`}
    </button>
  );
}
